import { OperationSpec, OperationType } from '@sqior/js/operation';

export const DemoModePath = 'demo-mode';

export const RestartServerPath = 'system/server-restart';
export function RestartServer(): OperationSpec {
  return { type: OperationType.Add, path: RestartServerPath, data: '' };
}
